// extracted by mini-css-extract-plugin
module.exports = {"container":"sender-select_container__JQeZR","sender":"sender-select_sender__jJ7gf"};